export default __webpack_public_path__ + "static/media/1010.f5c75291.png";